import React from 'react'

export default function MyMapLayerDetail(props) {
    function getContainerStyle() {
        if(props.isMobileMode)return {display: "none" };    //モバイルモードの場合は非表示
        var margin_lr = 10;
        var swither_size = 230;
        var content_size = 350;
        var margin = 0;
        if(props.isShowSearchResultPanel && props.searchPanelVisible){
            if((props.width - (props.width > 400 ? 400 : props.width)) > ((swither_size *2) + (margin_lr * 2) + content_size)){
                margin = (props.width > 400 ? 400 : props.width) + ((props.width - (props.width > 400 ? 400 : props.width)) / 2);
                return {
                    display: "flex",
                    margin:"10px 10px 30px "+ margin +"px"
                };
    
            }else{
                return {display: "none" };
            }
        }else{
            if(props.width > ((swither_size *2) + (margin_lr * 2) + content_size)){
                margin = props.width / 2;
                return {
                    display: "flex",
                    margin:"10px 10px 30px "+ margin +"px"
                };
    
            }else{
                return {display: "none" };
            }
        }
    }
    return (
        (props.mapLayerDetailItems !== undefined &&
            <div className="MyMapLayerDetail" style={getContainerStyle()}>
                {Object.keys(props.mapLayerDetailItems).map(key => 
                    ( props.showLayerDetails[key] && Object.keys(props.mapLayerDetailItems[key]).length >0 &&
                        (!props.mapLayerDetailItems[key].authority || props.mapLayerDetailItems[key].authority.startsWith(window.SIMPL.userAuthority) || props.userAuthorities.some(item => props.mapLayerDetailItems[key].authority.startsWith(item))) &&
                        <div className="Detail_Group" key={props.mapLayerDetailItems[key].id}>
                            {props.mapLayerDetailItems[key].usageURL ?
                            <a className="Detail_title" href={window.SIMPL.blobUrl + window.SIMPL.layerPath + props.mapLayerDetailItems[key].usageURL + window.SIMPL.blobParams}
                                target="_blank" rel="noopener noreferrer">
                                    {props.mapLayerDetailItems[key].title}
                                    </a>
                            :
                            <span　className="Detail_title">{props.mapLayerDetailItems[key].title}</span>

                            }
                            {props.mapLayerDetailItems[key].usage && 
                                <div style={{display:"flex",flexDirection:"row",flexWrap:"wrap"}}>
                                    {props.mapLayerDetailItems[key].usage.map(usageitem =>
                                        (
                                            <span className="Detail_item" key={usageitem.id} >
                                                <span className={"Detail_item_"+usageitem.type} style={{backgroundColor:usageitem.color}}></span>
                                                <label className="Detail_item_label">
                                                        {usageitem.title}
                                                </label>
                                            </span>
                                        )
                                    )}
                                </div>
                            }
                        </div>
                    )
                )}
            </div>
        )
    );
}
